import ReactModal from 'react-modal';
import dayjs from 'dayjs';

import Button from 'atoms/button';

export default function NewAppointmentSuccessModal({
  isOpen,
  onClose,
  service,
  animal,
  date,
}) {
  return (
    <ReactModal
      ariaHideApp={false}
      isOpen={isOpen}
      className="new-appointment-success-modal"
      onRequestClose={onClose}
    >
      <div className="flex-column align-center checkout-success-modal-content">
        <h2 className="f20 mb-12">Appointment confirmed</h2>
        <p className="f15 text-center mb-28">
          You&apos;ve made a new {service?.name} appointment for {animal?.name}{' '}
          on{' '}
          {dayjs(`${date?.date}T${date?.timeStart}`).format(
            'dddd, MMMM D, h:mm a'
          )}
          .
        </p>
        <Button text="Done" size="medium" onClick={onClose} />
      </div>
    </ReactModal>
  );
}
